import { Icon, ICONS } from '@bob/library'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import React, { ReactNode } from 'react'

import * as SC from './LessonInfo.style'

export interface LessonInfoTextProps {
  productNames: string[]
  lesson: {
    title: string
    description?: string | null
    duration?: string | null
    level?: string | null
    grade?: string | null
    suitableForHybridTeaching: boolean
  }
  belowTitle: ReactNode
}

export const LessonInfoText = ({ productNames, lesson, belowTitle }: LessonInfoTextProps) => {
  const t = useStaticText()

  return (
    <SC.Text>
      <SC.Product>{productNames.join(', ')}</SC.Product>
      <SC.Title data-testid={'lesson_title'}>{lesson.title}</SC.Title>
      {belowTitle}
      {lesson.description && (
        <Markdown data-testid={'lesson_description'} markdown={lesson.description} />
      )}
      <SC.InfoWrapper>
        {lesson.duration && (
          <SC.InfoItem data-testid={'lesson_duration'}>
            <Icon icon={ICONS.CLOCK} size={20} />
            {lesson.duration}
          </SC.InfoItem>
        )}
        {lesson.level && (
          <SC.InfoItem data-testid={'lesson_level'}>
            <Icon icon={ICONS.BRICK} size={20} />
            {lesson.level}
          </SC.InfoItem>
        )}
        {lesson.grade && (
          <SC.InfoItem data-testid={'lesson_grade'}>
            <Icon icon={ICONS.GRADUATE} size={20} />
            {lesson.grade}
          </SC.InfoItem>
        )}
        {lesson.suitableForHybridTeaching && (
          <SC.InfoItem data-testid={'lesson_hybrid'}>
            <Icon icon={ICONS.DISPLAY} size={20} />
            {t.plans_lessons_worksheets.hybrid}
          </SC.InfoItem>
        )}
      </SC.InfoWrapper>
    </SC.Text>
  )
}
